<template>
    <div>
        <h1 style="font-size: 24px; color: black;">平台变现奖励金</h1>
        <el-card shadow="never">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <span> 接入媒体： </span>
                    <el-select v-model="queryData.mediaId">
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <span> 日期：</span>
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="monthrange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                    >
                    </el-date-picker>
                </el-col>
                    <el-button type="primary" @click="queryList">查询</el-button>
                    <el-button type="primary" @click="showDetails('创建')">创建</el-button>
            </el-row>
        </el-card>
        <h1></h1>
        <el-table border :data="topicList">
            <el-table-column label="月份时间" prop="dt">
                <template slot-scope="scope">
                    {{ scope.row.dt | dateFormat}}
                </template>
            </el-table-column>
            <el-table-column label="接入媒体" prop="mediaId">
                <template slot-scope="scope">
                    {{ scope.row.mediaId | commonFilter(mediaObj)}}
                </template>
            </el-table-column>
            <el-table-column label="付款公司" prop="companyId">
                <template slot-scope="scope">
                    {{ scope.row.companyId | commonFilter(companyObj)}}
                </template>
            </el-table-column>
            <el-table-column label="奖励金" prop="rewardMoney"></el-table-column>
            <el-table-column label="关联OA开票ID" prop="invoiceId"></el-table-column>
            <el-table-column label="开票金额" prop="invoiceMoney"></el-table-column>
            <el-table-column label="是否已回款" prop="backMoney">
                <template slot-scope="scope">
                    {{ scope.row.backMoney | yesOrNo }}
                </template>
            </el-table-column>
            <el-table-column label="备注" prop="remarks"></el-table-column>
            <el-table-column label="操作" align="center">
                <el-button  plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
            </el-table-column>
        </el-table>
        <el-row>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="pageSizes"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </el-row>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px" >
            <el-form :model="form.formData"  ref="form.formData" label-width="150px" :rules="form.rules">
                <el-form-item label="月份时间:" prop="dt">
                    <el-date-picker style="width: 300px"
                                    v-model="form.formData.dt"
                                    type="month"
                                    placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="接入媒体:" prop="mediaId">
                    <el-select  v-model="form.formData.mediaId" >
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款公司:" prop="companyId">
                    <el-select  v-model="form.formData.companyId" >
                        <el-option
                                v-for="(value,key) in companyObj"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖励金:" prop="rewardMoney">
                    <el-input-number style="width: 300px" v-model="form.formData.rewardMoney" :precision="2" :step="0.01" :min="0.01"></el-input-number>
                </el-form-item>
                <el-form-item label="备注:" prop="remarks">
                    <el-input style="width: 300px" v-model="form.formData.remarks" ></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        FcMonthRewardsList, updateFcMonthRewards
    } from "@/http/financialApi";
    import settingMix from '@/utils/mix/common-setting'
    import pageMix from '@/utils/mix/page'
    import DateUtil from '@/utils/DateUtil'
    import objUtil from '@/utils/ObjUtil'
    export default {
        name: "FcMonthRewards",
        mixins: [settingMix, pageMix],
        data() {
            return {
                dialogVisible: false,
                dialogTitle: '',
                queryData: {
                    appId: -1,
                    mediaId: -1,
                    timeDate: ['', ''],
                },
                topicList: [],
                needGetMedia: true,
                mediaType: 1,
                mediaObj: {},
                needGetCompany: true,
                companyObj: {},
                form: {
                    createData:{
                        "id" : null,
                        "dt" :'',
                        "mediaId" :'',
                        "companyId" :'',
                        "rewardMoney" : 0.0,
                        "invoiceId" : 0,
                        "invoiceMoney" : 0.0,
                        "backMoney" : 0,
                        "remarks" :''
                    },
                    formData: {},
                    rules: {
                        dt: [{ required: true, message: '请选择时间', trigger: 'change' }],
                        mediaId: [{ required: true, message: '请选择媒体', trigger: 'change' }],
                        companyId: [{ required: true, message: '请选择付款公司', trigger: 'change' }],
                        rewardMoney: [{ required: true, message: '请填写奖励金', trigger: 'blur' }]
                    }
                }
            }
        },
        methods: {
            showDetails(title, row) {
                console.log(row);
                this.form.formData = objUtil.clone(this.form.createData)
                this.dialogTitle = title;
                this.dialogVisible = true;
                if(row){
                    this.form.formData = objUtil.clone(row)
                }
            },
            confirm(){
                this.$refs["form.formData"].validate((valid) => {
                    if (valid) {
                        updateFcMonthRewards(this.form.formData).then(resp=> {
                            if (resp.data.status===0){
                                this.dialogVisible = false;
                                this.queryList();
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            cancel(){
                this.dialogVisible=false;
            },
            queryList() {
                let queryTrueData = {mediaId: this.queryData.mediaId}
                queryTrueData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
                queryTrueData = this.mergePage(queryTrueData)
                FcMonthRewardsList(queryTrueData).then(resp => {
                    if (resp.data.status === 0) {
                        this.topicList = resp.data.info.content
                        this.setTotal(resp.data.info)
                    }
                })
            },
            initDateRange() {
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(1)
            }
        },
        created() {
            this.initDateRange()
            this.queryList()
        },
    }
</script>

<style scoped>
</style>
